import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, ButtonBase, useMediaQuery } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from 'layout/MainLayout/LogoSection';
import { drawerWidth } from 'store/constant';

// assets
import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const goftino = document.getElementById('goftino_w');
    if (goftino) goftino.style.display = drawerOpen ? 'block' : 'none';

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'none', md: 'none' } }}>
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>
            <Box
                sx={{ position: 'fixed', display: { xs: 'block', md: 'none' }, right: drawerWidth - 60, top: 10, px: 1, py: 1, zIndex: 1 }}
            >
                <ButtonBase onClick={drawerToggle}>
                    <IconMenu2 stroke={1.5} size={28} />
                </ButtonBase>
            </Box>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        //height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        paddingTop: !matchUpMd ? '40px' : 0
                    }}
                    options={{
                        useBothWheelAxes: false,
                        suppressScrollX: true
                    }}
                >
                    <MenuList />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 } }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                PaperProps={{
                    sx: {
                        left: 'unset !important',
                        right: '0 !important',
                        scrollbarWidth: 'thin'
                    }
                }}
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderLeft: 'none',
                        pt: 1,
                        [theme.breakpoints.up('md')]: {
                            //top: '88px',
                            //pt: 7.5
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
